import React from "react"

export const Main: React.FC<{}> = (): JSX.Element => {
  return <div> about</div>
}
export default Main
